/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "dc8f350713365566a012aca0796b3bd5dfe2585a";
